module.exports = __webpack_public_path__ + "img/glasstype-multifocalsunglasses.43fee6fc.svg";